import React from 'react';
import LodgingCard from './LodgingCard';

const LodgingsList = ({ lodgings = [] }) => {
  if (lodgings.length === 0) {
    return <div className="lodgings-list">No lodgings to display.</div>;
  }

  return (
    <div className="lodgings-list grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {lodgings.map((l, i) => {
        const slugKey = typeof l.slug === 'string'
          ? l.slug
          : l.slug?.current;

        return (
          <LodgingCard
            key={slugKey || `lodging-${i}`}
            lodging={l}
          />
        );
      })}
    </div>
  );
};

export default LodgingsList;
